export default "05f7377835288751.png"